import axios from "axios";

export const cashRegisterMovementApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/cash-register-movement`,
  headers: {
    "Content-Type": "application/json",
  },
});
